import {
  EventDateRangeBadge,
  EventSessionCountBadge,
  EventStatusBadge,
  EventIconSummary,
  PageHeader,
} from "@components"

import { hasMeetingType } from "@helpers"

import PropTypes from "prop-types"

const Header = ({ 
  actions = null, 
  event = null, 
  icon, 
  title, 
}) => (
  <PageHeader
    actions={actions}
    subTitle={event?.title}
    title={title}
    icon={icon}
    bgColor="bg-indigo-900"
    contentBottom={
      <div className="flex items-center justify-between">
        <EventIconSummary
          iconClassNames="text-white"
          isVenue={hasMeetingType("VENUE", event.meetingTypes)}
          isPhone={hasMeetingType("PHONE", event.meetingTypes)}
          isVc={hasMeetingType("VC", event.meetingTypes)}
          isVcTimer={event.vc_auto_disconnect}
          isOpenToParents={event.open_parents}
          isOpenToStaff={event.open_staff}
          isParentBookingsDisabled={event.disable_parent_bookings}
        />
        
        <div className="absolute flex flex-wrap gap-2 right-12">
          <EventDateRangeBadge startDate={event?.start_date} endDate={event?.end_date} />
          
          <div className="hidden lg:block">
            <EventStatusBadge size="md" startDate={event?.start_date} endDate={event?.end_date} />
          </div>
          
          <div className="hidden 2xl:block">
            <EventSessionCountBadge size="md" count={event?.sessions?.length ?? 0} />
          </div>
        </div>
      </div>
    }
  />
)

Header.propTypes = {
  actions: PropTypes.node,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  event: PropTypes.object,
}

export default Header
